import { Stack } from "capitalrx-components-2.0/lib/layout";
import styles from "./PageNotFound.module.scss";

export const PageNotFound = () => {
  return (
    <Stack alignment="center" style={{ paddingTop: "100px" }}>
      <div className={styles["PageTitle"]} data-testid="test__404">404</div>
    </Stack>
  );
};
